import qs, { type ParsedQs } from 'qs';
import { isIgnoredUrlParam } from './algoliaConstants';

const algoliaUrlToSearchState = ({ search }: Location): ParsedQs => {
  const parsed = qs.parse(search.slice(1));
  const filtered: ParsedQs = {};
  for (const [key, value] of Object.entries(parsed)) {
    if (!isIgnoredUrlParam(key)) {
      filtered[key] = value;
    }
  }
  return filtered;
};

export default algoliaUrlToSearchState;
